export const environment = {
  production: true,
  // loginScopes: ['api://timetable-service/api_access'],
  loginScopes: ['api://student-portal-prod/Portal.View'],
  msalConfig: {
    auth: {
      clientId: '61066488-1dae-4c2b-8bf4-08ff545a3b6d', // App Registration (client) ID
      redirectUri: '/', // Must be registered on Azure Portal/App Registration. Defaults to window.location.origin
      authority:
        'https://login.microsoftonline.com/65b52940-f4b6-41bd-833d-3033ecbcf6e1',
      postLogoutRedirectUri: '/logged_out', // Indicates the page to navigate after logout.
      navigateToLoginRequestUrl: false,
      tenantId: '65b52940-f4b6-41bd-833d-3033ecbcf6e1',
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false,
    },
    system: {
      loggerOptions: {
        loggerCallback: () => {
          return;
        },
      },
    },
  },
};

export default environment;
